import { render, staticRenderFns } from "./OffproductTable.vue?vue&type=template&id=7a4ad09d&scoped=true"
import script from "./OffproductTable.vue?vue&type=script&lang=js"
export * from "./OffproductTable.vue?vue&type=script&lang=js"
import style0 from "./OffproductTable.vue?vue&type=style&index=0&id=7a4ad09d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4ad09d",
  null
  
)

export default component.exports